import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import Visits from './Visits';
import PublicVisitTracking from './PublicVisitTracking';

function VisitsRoute() {
  const [searchParams] = useSearchParams();
  const hasPublicTrackingParams =
    Boolean(searchParams.get('registerVisit')) && Boolean(searchParams.get('token'));

  if (hasPublicTrackingParams) {
    return <PublicVisitTracking />;
  }

  return (
    <PrivateRoute>
      <Visits />
    </PrivateRoute>
  );
}

export default VisitsRoute;
